import type { Observation } from '@/types';

/** Fusionne des listes d’observations sans doublon (cle ou id). */
export function mergeObservations(...lists: Observation[][]): Observation[] {
  const map = new Map<string, Observation>();
  for (const list of lists) {
    for (const obs of list) {
      const key = (obs.cle || obs.id || '').trim();
      if (!key) continue;
      map.set(key, obs);
    }
  }
  return Array.from(map.values());
}
